import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

export default function AddressLabel({ street, street2, city, state, postalCode, type }) {
  return (
    <Text
      component="span"
      display="flex"
      flexDirection="column"
      gap="5px"
      paddingLeft="18px"
    >
      <Text
        color="primary"
        size="xl"
        weight="medium"
      >
        {street}
      </Text>
      {street2 && (
        <Text
          color="primary"
          size="xl"
          weight="medium"
        >
          {street2}
        </Text>
      )}
      <Text
        color="primary"
        size="xl"
        weight="medium"
      >{`${city}, ${state} ${postalCode}`}</Text>
      <Text
        color="secondary"
        size="lg"
      >
        {type}
      </Text>
    </Text>
  );
}

AddressLabel.propTypes = {
  street: PropTypes.string.isRequired,
  street2: PropTypes.string,
  city: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  postalCode: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
};
